import { ReactionAnalyticsEvent } from '../index.types';

/**
 * Timing constants for reaction popover animations
 */
export const REACTION_POPOVER_HOVER_DELAY = 300;
export const REACTION_POPOVER_HIDE_DELAY = 200;

/**
 * Available emoji reactions configuration
 * Each reaction includes the emoji, internal name, and analytics event
 */
export const AVAILABLE_REACTIONS: {
  emoji: string;
  name: string;
  analyticsEvent: ReactionAnalyticsEvent;
}[] = [
  { emoji: '👍', name: 'thumb', analyticsEvent: 'chat_reaction_thumb' },
  { emoji: '❤️', name: 'heart', analyticsEvent: 'chat_reaction_heart' },
  { emoji: '😂', name: 'laugh', analyticsEvent: 'chat_reaction_laugh' },
  { emoji: '😮', name: 'surprise', analyticsEvent: 'chat_reaction_surprise' },
  { emoji: '😢', name: 'sad', analyticsEvent: 'chat_reaction_sad' },
];

/**
 * Array of available reaction emojis for easy iteration
 */
export const REACTION_EMOJIS = AVAILABLE_REACTIONS.map((r) => r.emoji);

/**
 * Get the analytics event name for a reaction
 * @param emoji - The emoji character
 * @param isRemoval - Whether this is a removal event (default: false)
 * @returns The analytics event name or null if emoji not found
 */
export const getReactionAnalyticsEvent = (
  emoji: string,
  isRemoval = false
): ReactionAnalyticsEvent | null => {
  const reaction = AVAILABLE_REACTIONS.find((r) => r.emoji === emoji);
  if (!reaction) return null;

  return isRemoval
    ? (`chat_reaction_removed_${reaction.name}` as ReactionAnalyticsEvent)
    : reaction.analyticsEvent;
};